// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Lottie, i_lottie_props} from '../lib/lottie';
import {img_url} from './img_url';
import {use_in_view} from '../lib/use_in_view';
import {t_element_size, use_element_size} from '../lib/screen_util';
// @ts-ignore
import {App_context} from 'hola_app_context';
import {use_scrolled} from '../ui_utils';

interface i_on_view_animation_props extends
    Pick<i_lottie_props, 'src'|'animation'|'loop'|'autoplay'> {
    size: t_element_size;
    cls?: string;
    start_frame?: number;
    offset?: number;
    repeat?: boolean;
}
export const On_view_animation = (props:i_on_view_animation_props)=>{
    const {src, cls, start_frame = 0, size, offset = 0, repeat = false,
        ...lottie_props} = props;
    const {is_client} = useContext(App_context);
    const inited = useRef(false);
    const ref = useRef<HTMLDivElement>();
    const [frame, set_frame] = useState(start_frame);
    const in_view = use_in_view(ref);
    const [w, h] = use_element_size(size);
    const {direction} = use_scrolled();
    const bottom = direction == 'up' ? '100%' : `-${offset}px`;
    useEffect(()=>{
        if (!inited.current && in_view)
        {
            inited.current = true;
            return void set_frame(undefined);
        }
        if (!repeat)
            return;
        set_frame(in_view ? undefined : 0);
    }, [in_view, repeat]);
    return <div className={cls} style={{position: 'relative'}}>
      {is_client && <Lottie src={img_url(src)} width={w} height={h}
        fixed_frame={frame} {...lottie_props}/>}
      <div ref={ref} style={{position: 'absolute', bottom}}/>
    </div>;
};
